(function () {
  function mountMap(root) {
    (root || document).querySelectorAll('.ak-contact-map__canvas:not([data-map-ready])').forEach(function (element) {
      if (!window.L) return;
      var latitude = Number(element.dataset.latitude);
      var longitude = Number(element.dataset.longitude);
      var map = window.L.map(element, { scrollWheelZoom: false, zoomControl: true, attributionControl: true }).setView([latitude, longitude], 17);
      window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        minZoom: 3, maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap contributors</a>'
      }).addTo(map);
      window.L.circleMarker([latitude, longitude], { radius: 8, color: '#ffffff', weight: 3, fillColor: '#b85a28', fillOpacity: 1 })
        .bindPopup('Akerax mailing address: ' + element.dataset.address)
        .addTo(map);
      element.dataset.mapReady = 'true';
      window.requestAnimationFrame(function () { map.invalidateSize(); });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { mountMap(); });
  document.addEventListener('shopify:section:load', function (event) { mountMap(event.target); });
}());
